<script lang="ts">
    import { List, ListGroup, ListItem } from 'framework7-svelte';
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n'; 
    
    import FloatingButton from '../FloatingButton.svelte';
    import {SELECTABLE_MEASUREMENT_METRIC_FIELDS} from "../../constants/measurement-table-constants";
    import {darkmode} from "../../utils/darkmode";
    import {getMeasurementFieldLabel, getMeasurementFieldUnit} from "../../i18n/translate";

    export let selectedMeasurementProperty: string | null;

    const eventDispatcher = createEventDispatcher();

    function handleChangeMeasurementProperty(indicator: string | null) {
        selectedMeasurementProperty = indicator;
        eventDispatcher('indicatorSelected', indicator);
    }

    $: selectedProperty = selectedMeasurementProperty;
</script>

<FloatingButton
    label={selectedProperty ? getMeasurementFieldLabel(selectedProperty) + ' (' + getMeasurementFieldUnit(selectedProperty) + ')' : $_('pages.project.NO_MEASUREMENTS_AVAILABLE')}
    active={!!selectedProperty}
    activeIcon="check"
    inactiveIcon=""
>
    <List ul={false}>
        <ListGroup class="popover-group">
            {#each SELECTABLE_MEASUREMENT_METRIC_FIELDS as property}
                <ListItem
                    class="no-icon {$darkmode ? 'colored-list-item' : ''}"
                    radio
                    title={getMeasurementFieldLabel(property)}
                    checked={selectedProperty === property}
                    on:change={() => handleChangeMeasurementProperty(property)}
                />
            {/each}
        </ListGroup>
    </List>
</FloatingButton>

<style lang="scss">
    @import '../../assets/scss/colors';

    :global(.popover-group) {
        background: $secondary-container;
    }

    :global(.colored-list-item .item-title) {
      color: $surface-on-variant;
    }

    :global(.no-icon .icon-radio) {
        display: none;
    }
</style>
